module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$parent.isAdminPage(_vm.$route.path)) ? _c('footer', {
    staticClass: "footer"
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b4aa57e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 642
// module chunks = 97